var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelFax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .065)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#5C5C5C",
    width: 50,
    height: 50,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 40c-6.067 0-11.221-2.206-15.758-6.742C12.206 28.72 10 23.567 10 17.5c0-.285.112-.557.314-.757l6.428-6.429a1.074 1.074 0 0 1 1.63.135l5.357 7.5a1.07 1.07 0 0 1-.115 1.38l-4.969 4.97c.18.666.79 2.193 2.827 4.23 2.029 2.029 3.55 2.64 4.232 2.824l4.967-4.967a1.07 1.07 0 0 1 1.38-.114l7.5 5.357a1.072 1.072 0 0 1 .135 1.629l-6.429 6.428c-.2.202-.472.314-.757.314zM12.147 17.94c.1 5.345 2.05 9.742 6.11 13.803 4.062 4.06 8.458 6.01 13.803 6.11l5.216-5.216-5.732-4.095-4.715 4.716c-.2.201-.473.314-.758.314-.264 0-2.686-.1-6.114-3.529-3.43-3.428-3.529-5.85-3.529-6.114 0-.285.113-.557.314-.758l4.716-4.715-4.094-5.732-5.217 5.216z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelFax);
export default __webpack_public_path__ + "static/media/tel-fax.b5ea75864d97d624be96c6fd065e7370.svg";
export { ForwardRef as ReactComponent };